import React, { useEffect, useState } from 'react'

const Step3 = ({ formData, setFormData }) => {
    const [value, setValue] = useState("")
    useEffect(() => {
        console.log(formData)
    }, [formData])



    const q5 = ["רכב פרטי בבעלותנו", "אמבולנס", "תחבורה ציבורית", "אחר"]
    const q6 = ["בבית", "בשטח ציבורי", "ברכב", "במסגרת חינוכית"]
    return (
        <div className='w-full flex flex-col items-start p-4 ' style={{ direction: "rtl" }} >
            <p className='text-right'>5. באיזה אופן הגעתם לבית החולים לקבל טיפול?</p>


            {q5.map((q, index) => (
                <div key={index} className="flex items-center gap-2 mt-1">
                    <input
                        type='radio'
                        name='selectq5'
                        value={q}
                        id={`q5-${index}`}
                        checked={formData.q5 === q}
                        onChange={(e) => {
                            const selected = e.target.value;
                            setFormData({
                                ...formData,
                                q5: selected,
                                q5Other: selected === "אחר" ? formData.q5Other : ""
                            });
                        }}
                    />
                    {q === "אחר" && formData.q5 === "אחר" ? (
                        <input
                            type='text'
                            className='text-Black bg-LightBlue rounded-lg border-2 p-2 border-MidBlue outline-none'
                            placeholder='טקסט חופשי'
                            value={formData.q5Other}
                            onChange={(e) => setFormData({ ...formData, q5Other: e.target.value })}
                        />
                    ) : (
                        <label htmlFor={`q5-${index}`}>{q}</label>
                    )}


                </div>
            ))}

            {/* {q5.map((q,index)=>(
                // <div><input type='radio' name="selectq5" value={q} id={index} checked={value == q} onChange={(e) => { setValue(e.target.value) }} /> {q=="אחר"&&value == "אחר" ?<input type='text' className='text-Black bg-LightBlue rounded-lg border-2 p-2 border-MidBlue outline-none' placeholder='טקסט חופשי'/>:<label htmlFor={index}>{q}</label>}</div>
                <div><input type='radio' name="selectq5" value={q} id={index} checked={formData.q5 == q} onChange={(e) => { setFormData({...formData,q5:e.target.value}) }} /> {q=="אחר"&&formData.q5 == "אחר" ?<input type='text' className='text-Black bg-LightBlue rounded-lg border-2 p-2 border-MidBlue outline-none' placeholder='טקסט חופשי'/>:<label htmlFor={index}>{q}</label>}</div>
            ))} */}
            {/*             
            <div><input type='radio' name="selectq5" value={"לא"} id={"לא"} checked={value == "לא"} onChange={(e) => { setValue(e.target.value) }} /> <label htmlFor="לא">לא</label></div>
            <div><input type='radio' name="selectq5" value={"לא ידוע לי"} id={"לא ידוע לי"} checked={value == "לא ידוע לי"} onChange={(e) => { setValue(e.target.value) }} /> <label htmlFor="לא ידוע לי">לא ידוע לי</label></div>
            <div><input type='radio' name="selectq5" value={"לא ידוע לי"} id={"לא ידוע לי"} checked={value == "לא ידוע לי"} onChange={(e) => { setValue(e.target.value) }} /> <label htmlFor="לא ידוע לי">לא ידוע לי</label></div>
         */}
            <p className='text-right'>6. היכן נגרמה הכוויה?</p>
            {q6.map((q, index) => (
                <div key={index} className="flex items-center gap-2 mt-1">
                    <input
                        type='radio'
                        name='selectq6'
                        value={q}
                        id={`q6-${index}`}
                        checked={formData.q6 === q}
                        onChange={(e) => {
                            const selected = e.target.value;
                            setFormData({
                                ...formData,
                                q6: selected,
                                // q5Other: selected === "אחר" ? formData.q5Other : ""
                            });
                        }}
                    />
                    <label htmlFor={`q6-${index}`}>{q}</label>
                </div>
            ))}
        </div>
    )
}

export default Step3